import { render, staticRenderFns } from "./BasicUserInformation.vue?vue&type=template&id=2501a2a6&scoped=true"
import script from "./BasicUserInformation.vue?vue&type=script&lang=js"
export * from "./BasicUserInformation.vue?vue&type=script&lang=js"
import style0 from "./BasicUserInformation.vue?vue&type=style&index=0&id=2501a2a6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2501a2a6",
  null
  
)

export default component.exports